// extracted by mini-css-extract-plugin
module.exports = {"atAttention":"AtMovieAttention_atAttention__3yQEu"};